import cmsSettings from '../cmsSettings'
import { pageMetadataFields } from '../_shared'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  titleLeft,
  titleRight,
  products[]->{${pageMetadataFields}}
`

export const fragment = (name = 'productsInfiniteCarousel') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
